import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { DnaFilteredUserDna } from "../../../models/dna/dna.filtered-user-dna.model";
import { DnaService } from "../../../services/shared/dna.service";
import * as _ from 'lodash';

export interface ISelectedDna {
  dnaName: string;
  dnaId: number;
}

@Component({
  selector: 'app-dnaselector',
  templateUrl: './dnaselector.component.html',
  styleUrls: ['./dnaselector.component.scss']
})
export class DnaSelectorComponent implements OnInit {
  public availableClientList = [];
  public availableDnaList = [];

  public selectedClient: { clientName, clientId };
  public selectedDna: ISelectedDna;

  @Input()
  public defaultDna: {
    clientName: string,
    dnaName: string,
    dnaId: number,
    dnaLogo: string,
    dnaLogoBase64: string,
    colour1: string,
    colour2: string,
    colour3: string,
    colour4: string,
    colour5: string
  };

  @Output()
  public defaultDnaChanged = new EventEmitter();

  public filteredUserDna = new Array<DnaFilteredUserDna>();

  private filteredDnaSubsciption: Subscription;

  constructor(private dnaService: DnaService) {
  }

  public ngOnInit() {
    this.filteredDnaSubsciption =
      this.dnaService.filteredUserDnaList.subscribe((dnaList: Array<DnaFilteredUserDna>) => {

        this.availableDnaList = [];
        this.selectedClient = undefined;
        this.filteredUserDna = dnaList;

        this.availableClientList =
          this.filteredUserDna.map(x => { return { clientName: x.clientName, clientId: x.clientId } }).sort((a, b) => {
            return a.clientName < b.clientName ? -1 : 1
          });;

        this.availableClientList = _.map(
          _.uniq(
            _.map(this.availableClientList, function (obj) {
              return JSON.stringify(obj);
            })
          ), function (obj) {
            return JSON.parse(obj);
          }
        );

        this.availableClientList = this.availableClientList.sort((a, b) => {
          if (a.clientName.toLowerCase() > b.clientName.toLowerCase()) {
            return 1;
          } else if (a.clientName.toLowerCase() < b.clientName.toLowerCase()) {
            return -1;
          } else {
            return 0;
          }
        });

        if (this.filteredUserDna.filter(p => p.isDefault).length > 0) {
          var defaultDnaItem = this.filteredUserDna.filter(p => p.isDefault)[0];
          this.defaultDna = {
            clientName: defaultDnaItem.clientName,
            dnaName: defaultDnaItem.uname + (defaultDnaItem.currentVersion ? ' V' + defaultDnaItem.currentVersion : ''),
            dnaId: defaultDnaItem.dnaClientId,
            dnaLogo: defaultDnaItem.dnaLogo,
            dnaLogoBase64: defaultDnaItem.dnaLogoBase64,
            colour1: defaultDnaItem.colour1,
            colour2: defaultDnaItem.colour2,
            colour3: defaultDnaItem.colour3,
            colour4: defaultDnaItem.colour4,
            colour5: defaultDnaItem.colour5
          };
        }
      });

    this.dnaService.initializeDnaService();
  }

  public onClientChange() {
    this.selectedDna = undefined;

    if (this.selectedClient)
      this.availableDnaList = this.filteredUserDna.filter(p => p.clientId === this.selectedClient.clientId)
        .map(x => { return { dnaName: x.uname + (x.currentVersion ? ' V' + x.currentVersion : ''), dnaId: x.dnaClientId } });
    else
      this.availableDnaList = [];
  }

  public onDnaChange() {
    this.defaultDnaChanged.emit(this.selectedDna);
  }
}
